export enum EventBlockType {
    Source = 100,
    Transfer = 200,
    Queueing = 300,
    ArcQueueing = 350, // not used
    ArcClassification = 400,
    ArcDecisionMaking = 500,
    MeasureTaking = 600, // not used
    ArcMeasureTaking = 650,
    Information = 700,
    ArcInformation = 750, // not used
}
